import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-compatible-icons',
  templateUrl: './compatible-icons.component.html',
  styleUrls: ['./compatible-icons.component.scss']
})
export class CompatibleIconsComponent implements OnInit {
  @Input() compatibleId: string;
  public iconClass: string = '';
  constructor() { }

  ngOnInit() {
    if (this.compatibleId){
      this.compatibleId = String(this.compatibleId);
    }
    switch (this.compatibleId) {
      case '1': {
        this.iconClass = 'fa fa-check-circle color-green';
        break;
      }
      case '2': {
        this.iconClass = 'fa fa-times-circle color-red';
        break;
      }
      case '3': {
        this.iconClass = 'fa fa-minus-circle color-yellow';
        break;
      }
      case '4': {
        this.iconClass = 'fa fa-question-circle color-blue';
        break;
      }
      case '7': {
        this.iconClass = 'fa fa-ban color-gray';
        break;
      }
      case '6': {
        this.iconClass = '';
        break;
      }

    }
  }

}
